export const QRTypeFields = {
  email: ["email"],
  contact: ["name", "phone", "email"],
  calendar: ["title", "start_date", "end_date"],
  product_basic: [
    "product_id",   // Internal product identifier (SKU/ID)
    "serial",       // Unique serial number
    "batch",        // Batch/lot number for grouping
    "mfg_date",     // Manufacturing/stock date
    "name",         // Product name
    "category",     // Product category
    "location"      // Storage/shelf location
  ],
  event_ticket: [
    "ticket_id",     // Unique ticket identifier
    "event_name",    // Name of the event
    "date",          // Event date and time
    "seat",          // Seat/location information
    "ticket_type",   // Type of ticket (VIP, Standard, etc.)
    "attendee_name", // Name of the ticket holder
    "price"          // Ticket price
  ],
  tracking_logistics: [
    "serial_number",
    "barcode",
    "expiration_date",
    "manufacturing_date",
    "shipping_info"
  ],
  plain_text: ["columns", "separator"] // Added support for plain text type
}; 